<template>
  <div class="factorydetail">
    <nav-header />
    <div class="contents">
      <div class="contents-top">
        <div class="items">
          <div class="img-s" v-for="(val, index) in Factorys.images" :key="index">
            <img :src="baseUrl + val" style="width: 100%;height:auto"></img>
          </div>
        </div>
        <div class="items-l">
          <img :src="baseUrl + Factorys.image" style="width: 100%;height: auto;"></img>
        </div>
        <div class="items-t">
          <div class="p-title">{{ Factorys.title }}</div>
          <div class="p-model">{{ Factorys.model }}</div>
          <div class="phone_centers" @click="dialogVisible = true">
            <div class="p-n">
              <div style="font-size: 16px;font-weight: 400;">INQUIRE NOW</div>
            </div>
            <div class="call-tos">
              <div class="call-to"></div>
            </div>
          </div>
          <div class="p-share">
            <div class="share-t">
              Share
            </div>
            <div class="share-t" @click="goView('https://facebook.com/')">
              <img src="../assets/img/f1.png" style="width: 56%;height: auto;"></img>
            </div>
            <div class="share-t" @click="goView('https://www.instagram.com/')">
              <img src="../assets/img/in.png" style="width: 56%;height: auto;"></img>
            </div>
            <div class="share-t" @click="goView('https://twitter.com/')">
              <img src="../assets/img/twiter.png" style="width: 56%;height: auto;"></img>
            </div>
            <div class="share-t" @click="goView('https://www.skype.com/')">
              <img src="../assets/img/skype-3.png" style="width: 56%;height: auto;"></img>
            </div>
            <div class="share-t" @click="goView('https://web.wechat.com/')">
              <img src="../assets/img/wechat.png" style="width: 56%;height: auto;"></img>
            </div>
          </div>
          <div class="p-con">
            <div class="p-b-s">
              <div class="p-le" @click="getPrevProductList">
                <div class="arrow-le"></div>
                <div class="arrow-text">Prev</div>
              </div>
              <div class="p-ri" @click="getNextProductList">
                <div class="arrow-le"></div>
                <div class="arrow-text">Next</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contents-des">
        <div class="nav-title"><span>PRODUCT DESCRIPTION</span></div>
        <div class="nav-body">
          <div class="nav-content" v-html="Factorys.maincontent">
          </div>
        </div>
      </div>

      <div class="products-centers">
        <div class="products-nav-centers">
          <div class="products-titles">PRODUCT CENTER</div>
          <div class="products-contents">LATEST PRODUCTS</div>
        </div>
        <div class="swiper-s">
          <swiper class="swiper-container" :options="options">
            <swiper-slide v-for="(val, index) in products" :key="index">
              <div class="swiper-items " @click="goWindowPages(val.id)">
                <!--
                <div class="titles animate" data-ani="slideInRight" data-delay="500">{{ val.title }}</div>
                <div class="models animate" data-ani="slideInRight" data-delay="500">{{ val.model }}</div>-->
                <div class="item-line"></div>
                <div class="direction"></div>
                <img :src="baseUrl + val.image" alt="" width="100%" height="auto" />
                <div class="title">{{ val.title }}</div>
                <div class="model">{{ val.model }}</div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </div>
      </div>
    </div>
    <nav-footer />

    <el-dialog title="" :visible.sync="dialogVisible" :width="width" :modal="false" :before-close="handleClose">
      <div class="form-centers" style="width: 100%;">
        <div class="font">Are You Ready To Cooperate With Us</div>
        <el-form :model="form" label-width="0px" ref="loginForms" autocomplete="on" label-position="left"
          :rules="rules">
          <el-form-item>
            <el-input v-model="form.name" style="width: 49%;float: left;background: #fff;border-radius: 6px;"
              placeholder="Name"></el-input>
            <el-input v-model="form.email" style="width: 49%;float: right;background: #fff;border-radius: 6px;"
              placeholder="Email"></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 12px;">
            <el-input type="textarea" :rows="4" v-model="form.description" placeholder="Message"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="btn_send" @click.stop.prevent="Messageadds()">
              <span class="send_icon_text">SEND</span>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import NavHeader from "@/components/NavHeaders.vue";
import NavFooter from "@/components/NavFooter.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "about",
  data() {
    return {
      a: '',
      width: '60%',
      dialogVisible: false,
      form: {
        name: '',
        email: '',
        description: '',
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
      },
      products: [],
      options: {  // 设置slides可视数量
        slidesPerView: 3,
        // 设置滑块之间的距离
        spaceBetween: 15,
        // 其他你可能需要的配置
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      Factorys: "",
      id: this.$route.params.id,
      current_page: '',
      currentPage: 1, // 当前页码
      pageSize: 12, // 每页显示的行数
      total: 0,
      baseUrl: 'http://yingcheng.0576hs.com',
    };
  },
  components: {
    NavHeader,
    NavFooter,
    Swiper,
    SwiperSlide,
  },
  mounted() {
    this.$nextTick(() => {
      this.handleAnimate()
      addEventListener('scroll', this.handleAnimate)
    })
  },
  destroyed() {
    removeEventListener('scroll', this.handleAnimate)
  },
  created() {
    let self = this
    document.documentElement.scrollTop = "0px"
    self.init()
    self.getProductList()
    setTimeout(this.handleAnimate, 1000)
    let viewportWidth = document.documentElement.clientWidth

    if (viewportWidth < 440) {
      self.width = '90%'
    }
    //this.$layer.msg('你好')
    if (viewportWidth < 440) {
      self.options = {  // 设置slides可视数量
        slidesPerView: 1,
        // 设置滑块之间的距离
        spaceBetween: 15,
        // 其他你可能需要的配置
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      }
    }
  },
  methods: {
    goWindowPages(val){
      window.open('http://yingcheng.0576hs.com/#/detail/'+val)
    },
    goViewPages(val) {
      //console.log('sssbb')
      let self = this
      self.$router.push(val);
    },
    handleClose(){
      this.dialogVisible=false
    },
    Messageadds() {
      let self = this;
      if (!self.form.name) {
        //self.$layer.msg('Please Name');
        this.$message.error('Please Name');
        return
      }
      if (!self.form.email) {
        //self.$layer.msg('Please email');
        this.$message.error('Please email');
        return
      }
      if (!self.form.description) {
        //self.$layer.msg('Please Message');
        this.$message.error('Please Message');
        return
      }
      this.$api.mall
        .Messageadd({
          name: self.form.name,
          description: self.form.description,
          email: self.form.email,
        })
        .then((res) => {
          if (res.code == 1) {
            self.$message.success("success");
            self.reset();
          } else {
            self.$message.error(res.msg);
          }
        });
    },
    goView(url) {
      window.open(url)
    },
    // 获取商品信息
    getProductList() {
      let self = this
      let id = '16'
      this.$api.mall.getProductList({ page: 1, limit: 12 }).then((res) => {
        self.products = res.data.data.data
        this.current_page = res.data.data.current_page
        this.total = res.data.data.total
      })
    },
    getPrevProductList() {
      let self = this
      if (self.currentPage <= 1) {
        self.$layer.msg("Please Right")
        return
      }
      self.currentPage--
      let id = '16'
      this.$api.mall.getProductList({ page: self.currentPage, limit: 1 }).then((res) => {
        if (res.data.data.data.length > 0) {
          self.Factorys = res.data.data.data[0]
        }
        this.current_page = res.data.data.current_page
        this.total = res.data.data.total
      });
    },
    // 获取商品信息
    getNextProductList() {
      let self = this
      if (this.currentPage > this.current_page) {
        self.$layer.msg("Please Left")
        return
      }
      self.currentPage++
      let id = '16'
      this.$api.mall.getProductList({ page: self.currentPage, limit: 1 }).then((res) => {
        if (res.data.data.data.length > 0) {
          self.Factorys = res.data.data.data[0]
        }
        this.current_page = res.data.data.current_page
        this.total = res.data.data.total
      });
    },
    backs() {
      history.go(-1)
    },
    handleAnimate() {
      let top = pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      let vh = document.documentElement.clientHeight;
      let dom = document.querySelectorAll(".animate");
      [].slice.call(dom).forEach(v => {
        if (top + vh > v.offsetTop) {
          var delay = v.dataset.delay;
          if (delay) {
            setTimeout(() => {
              v.style.opacity = 1
              v.classList.add(v.dataset.ani)
            }, delay)
          } else {
            v.style.opacity = 1;
            v.classList.add(v.dataset.ani)
          }
        } else {
          v.classList.remove(v.dataset.ani)
          v.style.opacity = 0
        }
      })
    },
    init() {
      let self = this;
      this.$api.mall
        .getProductDetail({
          id: self.id,
        })
        .then((ress) => {
          let res = ress.data.data;
          console.log(res, "Ssbbb");
          self.Factorys = res;
        });
    },
  },
};
</script>
<style lang="scss" scoped>

 /* 定义心跳跳动动画 */
 @keyframes pulses {
    0% {
      transform: scale(1);
      opacity: 0.7;
    }

    50% {
      transform: scale(1.2);
      opacity: 1;
    }

    100% {
      transform: scale(1);
      opacity: 0.7;
    }
  }

@media screen and (min-width: 440px) and (max-width:8000px) {

  .form-centers {
    width: 100%;
    padding: 80px;
    overflow: hidden;
    box-sizing: border-box;
    background: #252525de;
    position: absolute;
    width: 28px;
    height: 28px;
    margin-top: 28px;
    position: absolute;

    .font {
      font-size: 35px;
      text-align: center;
      color: #fff;
      font-weight: 600;
      line-height: 32px;
      margin-bottom: 30px;
      width: 100%;
      overflow: hidden;
    }

    .btn_send {
      color: #02999d;
      width: 160px;
      cursor: pointer;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: none;
      border: 2px solid #02999d;
      .send_icon_text {
        width: 58px;
        font-size: 18px;
        line-height: 50px;
        margin: 0px auto;
        display: block;
        background: url(../assets/img/send.png) no-repeat right;
        background-size:22px;
        padding-right: 28px;
        text-align: center;
      }
    }
  }
}

@media screen and (min-width: 1024px) and (max-width:1600px) {
  
  .form-centers {
    width: 100%;
    padding: 12px;
    overflow: hidden;
    box-sizing: border-box;
    background: #252525de;
    margin-top: 28px;

    .font {
      font-size: 35px;
      text-align: center;
      color: #fff;
      font-weight: 600;
      line-height: 32px;
      margin-bottom: 30px;
      width: 100%;
      overflow: hidden;
    }

    .btn_send {
      color: #02999d;
      width: 160px;
      cursor: pointer;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: none;
      border: 2px solid #02999d;

      .send_icon_text {
        width: 58px;
        font-family:'Rany-Bold';
        font-size: 18px;
        line-height: 50px;
        margin: 0px auto;
        display: block;
        background: url(../assets/img/send.png) no-repeat right;
        background-size: 22px;
        padding-right: 28px;
        text-align: center;
      }
    }
  }
}

@media screen and (min-width: 0px) and (max-width:1024px) {
  
  .form-centers {
    width: 100%;
    padding: 12px;
    overflow: hidden;
    box-sizing: border-box;
    background: #252525de;
    margin-top: 28px;

    .font {
      font-size: 35px;
      text-align: center;
      color: #fff;
      font-weight: 600;
      line-height: 32px;
      margin-bottom: 30px;
      width: 100%;
      overflow: hidden;
    }

    .btn_send {
      color: #02999d;
      width: 160px;
      cursor: pointer;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: none;
      border: 2px solid #02999d;

      .send_icon_text {
        width: 58px;
        font-family:'Rany-Bold';
        font-size: 18px;
        line-height: 50px;
        margin: 0px auto;
        display: block;
        background: url(../assets/img/send.png) no-repeat right;
        background-size: 22px;
        padding-right: 28px;
        text-align: center;
      }
    }
  }
}

@media screen and (min-width: 0px) and (max-width:1024px) {
  .factorydetail {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;

    .swiper-button-next:after,
    .swiper-container-rtl .swiper-button-prev:after {
      content: '' !important;
    }

    .swiper-button-prev:after,
    .swiper-container-rtl .swiper-button-next:after {
      content: '' !important;
    }

    .swiper-button-next {
      background: url('~@/assets/img/right (1).png') no-repeat center #252525;
      opacity: 0.9;
      width: 42px;
      transform: skewX(-15deg);
      height: 42px;
      background-size: 50%;
    }

    .swiper-button-next:hover {
      background: url('~@/assets/img/right (1).png') no-repeat center #02999d;
      opacity: 0.9;
      -webkit-transition: 0.6s ease-in-out;
      transition: 0.6s ease-in-out;
      width: 42px;
      transform: skewX(-15deg);
      height: 42px;
      background-size: 50%;
    }

    .swiper-button-prev:hover {
      -webkit-transition: 0.6s ease-in-out;
      transition: 0.6s ease-in-out;
      background: url('~@/assets/img/left.png') no-repeat center #02999d;
      opacity: 0.9;
      width: 42px;
      transform: skewX(-15deg);
      height: 42px;
      background-size: 50%;
    }

    .swiper-button-prev {
      background: url('~@/assets/img/left.png') no-repeat center #252525;
      width: 42px;
      opacity: 0.9;
      height: 42px;
      transform: skewX(-15deg);
      background-size: 50%;
    }

    .animate {
      opacity: 0;
    }

    .fadeInUpBig {
      animation: fadeInUpBig 1s;
    }

    .rollIn {
      animation: rollIn 1s;
    }

    .slideInRight {
      animation: slideInRight 1s;
    }

    .bounceInLeft {
      animation: bounceInLeft 2s ease-in;
    }

    .bounceInRight {
      animation: bounceInRight 2s ease-in;
    }


    .products-centers {
      width: 100%;
      overflow: hidden;
      margin: 80px auto auto auto;
      box-sizing: border-box;
      padding: 0px 0px 90px 0px;

      .slide-mores:hover {
        background: #02999d;
        border: 1px solid #02999d;
        color: #fff;
        -webkit-transition: 0.6s ease-in-out;
        transition: 0.6s ease-in-out;
      }

      .slide-mores {
        cursor: pointer;
        margin: 50px auto auto auto;
        background: none;
        color: #252525;
        text-align: center;
        transform: skewX(-20deg);
        border: 1px solid #252525;
        width: 88px;
        font-size: 14px;
        line-height: 30px;

        .slide-more {
          transform: skewX(20deg);
        }
      }

      .swiper-s {
        width: 100%;
        overflow: hidden;
        position: relative;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;

        .swiper-container {
          width: 70%;
          overflow: hidden;
          position: relative;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 0px;
        }
      }

      .products-nav-centers {
        position: relative;
        width: 90%;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;
      }

      .products-leixing {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 212px;
        overflow: hidden;
      }

      .products-titles {
        color: #00959b;
        width: 100%;
        overflow: hidden;
        text-align: center;

      }

      .products-contents {
        color: #252525;
        width: 100%;
        overflow: hidden;
        text-align: center;
        font-size: 32px;
        margin-top: 30px;
        margin-bottom: 40px;
        font-weight: 600;
      }
/**
      .swiper-items:hover {

        padding: 25px 45px 0px 45px;
        border-bottom: 4px solid #02999d;

        .direction:hover {
          width: 35px;
          height: 35px;
          background: url('~@/assets/img/right (1).png') no-repeat center #02999d;
          opacity: 0.9;
          -webkit-transition: 0.6s ease-in-out;
          transition: 0.6s ease-in-out;
          background-size: 60%;
          margin-top: 10px;
          border: 2px solid #02999d;
          margin-bottom: 20px;
          display: block;
        }

        .direction {
          width: 35px;
          height: 35px;
          background: url("~@/assets/img/right2.png") no-repeat center;
          background-size: 60%;
          margin-top: 10px;
          border: 2px solid #02999d;
          margin-bottom: 0px;
          display: block;
          margin-bottom: 20px;
        }

        img {
          -webkit-transition: 0.6s ease-in-out;
          transition: 0.6s ease-in-out;
          transform: scale(1.06);
          //animation: pulse 2s infinite;
        }

        .models {
          font-size: 25px;
          width: 100%;
          overflow: hidden;
          font-weight: 600;
          color: #252525;
          -webkit-transition: 0.6s ease-in-out;
          transition: 0.6s ease-in-out;
          margin-top: 15px;
          display: block;
        }

        .model {
          display: none;
        }

        .title {
          display: none;
        }

        .titles {
          width: 100%;
          font-size: 18px;
          color: #02999d;
          box-sizing: border-box;
          padding: 0px;
          display: block;
          margin: 0px auto;
          overflow: hidden;
          -webkit-transition: 0.6s ease-in-out;
          transition: 0.6s ease-in-out;
        }
      }
        **/

      .swiper-items {
        width: 100%;
        overflow: hidden;
        box-sizing: border-box;
        padding: 45px 45px 0px 45px;
        background: #fff;
        cursor: pointer;

        .direction {
          display: none;

        }

        .models {
          display: none;
        }

        .titles {
          display: none;
        }

        .model {
          font-size: 25px;
          width: 100%;
          overflow: hidden;
          font-weight: 600;
          margin-bottom: 45px;
          color: #252525;
          margin-top: 25px;
        }

        .title {
          width: 100%;
          font-size: 18px;
          color: #02999d;
          box-sizing: border-box;
          padding: 0px;
          margin: 0px auto;
          overflow: hidden;
        }
      }
    }

    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }

    .v-enter-active {
      transition: all 1s ease;
    }

    .contents {
      width: 100%;
      overflow: hidden;
      margin: 61px auto auto auto;
      padding-top: 0px;
      background: #ededed;

      .contents-des {
        width: 90%;
        margin: 50px auto auto auto;
        overflow: hidden;
        padding: 0px;
        box-sizing: border-box;
   
        .nav-body {
          width: 100%;
          overflow: hidden;
          margin: -4px auto;
          padding: 0px;
          background: #fff;
          box-sizing: border-box;
       
      
          .nav-content {
            width: 100%;
            margin: 0px auto;
            overflow-y: scroll;
            padding: 10px;
            box-sizing: border-box;
              img{
              width: 100%;
              height: auto;
            }
          }
        }

        .nav-title {
          width: 100%;
          font-size: 25px;
          overflow: hidden;
          color: #252525;

          span {
            display: inline-block;
            overflow: hidden;
            padding-bottom: 20px;
            border-bottom: 4px solid #02999d;
          }
        }
      }

      .contents-top {
        width: 100%;
        overflow: hidden;
        margin: 0px auto;
        padding: 0px;
        box-sizing: border-box;
      }

      .items-l {
        width: 90%;
        cursor: pointer;
        margin: 50px auto auto auto;
        overflow: hidden;
        display: block;
        box-sizing: border-box;
      }

      .items-t {
        margin: 0px auto auto auto;
        width: 90%;
        overflow: hidden;
        padding: 0px;
        box-sizing: border-box;

        .p-con {
          width: 100%;
          overflow: hidden;
          margin: 50px auto auto;
          padding: 0px;
          box-sizing: border-box;

          .p-b-s {
            width: 258px;
            overflow: hidden;
            padding: 0px;
            box-sizing: border-box;

            .p-ri:hover {
              .arrow-text {
                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
                float: right;
                width: 74px;
                color: #02999d;
                text-align: center;
                margin-top: 13.5px;

              }

              .arrow-le {
                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
                background: url('~@/assets/img/right (1).png') no-repeat center #02999d;
                width: 42px;
                opacity: 0.9;
                float: right;
                height: 42px;
                transform: skewX(-15deg);
                background-size: 50%;
              }
            }

            .p-ri {
              width: 128px;
              float: right;
              overflow: hidden;
              padding: 0px;
              box-sizing: border-box;
              cursor: pointer;
              padding-right: 10px;

              .arrow-text {
                float: right;
                width: 74px;
                color: #252525;
                text-align: center;
                margin-top: 13.5px;

              }

              .arrow-le {
                background: url('~@/assets/img/right (1).png') no-repeat center #252525;
                width: 42px;
                opacity: 0.9;
                float: right;
                height: 42px;
                transform: skewX(-15deg);
                background-size: 50%;
              }
            }

            .p-le:hover {
              .arrow-text {

                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
                float: left;
                width: 74px;
                color: #02999d;
                text-align: center;
                border-right: 1px solid #d9d9d9;
                margin-top: 13.5px;

              }

              .arrow-le {
                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
                background: url('~@/assets/img/left.png') no-repeat center #02999d;
                width: 42px;
                opacity: 0.9;
                float: left;
                height: 42px;
                transform: skewX(-15deg);
                background-size: 50%;
              }
            }

            .p-le {
              width: 128px;
              float: left;
              cursor: pointer;
              overflow: hidden;
              padding: 0px;
              box-sizing: border-box;
              padding-left: 10px;

              .arrow-text {
                float: left;
                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
                width: 74px;
                color: #252525;
                text-align: center;
                border-right: 1px solid #d9d9d9;
                margin-top: 13.5px;

              }

              .arrow-le {
                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
                background: url('~@/assets/img/left.png') no-repeat center #252525;
                width: 42px;
                opacity: 0.9;
                float: left;
                height: 42px;
                transform: skewX(-15deg);
                background-size: 50%;
              }
            }
          }
        }

        .p-share {
          width: 100%;
          overflow: hidden;
          margin: 50px auto;
          border-top: 1px solid #d9d9d9;
          border-bottom: 1px solid #d9d9d9;
          padding: 0px;
          font-weight: 600;
          box-sizing: border-box;
          .share-t:nth-child(1){
            width: 22%;
          }
     

          .share-t {
            width: 15%;
            overflow: hidden;
            margin: 0px auto;
            float: left;
            padding: 0px;
            height: 85px;
            display: flex;
            align-items: center;
            /* 垂直居中 */
            justify-content: center;
            /* 水平居中，如果需要的话 */
            font-size: 25px;
            line-height: 85px;
            color: #252525;
            text-align: center;
          }

        }

        .phone_centers {
          width: 200px;
          margin-top: 50px;
          overflow: hidden;
          box-sizing: border-box;
          padding: 0px;
          position: relative;

          .call-tos {
            width: 20%;
            position: absolute;
            right: 12px;
            top: 0px;
            height: 50px;
            transform: skewX(-20deg);
            display: flex;
            align-items: center;
            /* 垂直居中 */
            justify-content: center;
            /* 水平居中，如果需要的话 */
            border: 1px solid #02999d;
            font-size: 14px;
            line-height: 30px;
            background: #02999d;

            .call-to {
              width: 20px;
              height: 14px;
              background: url('~@/assets/img/Arrow-s.png') no-repeat center;
              background-size: 20px 14px;
              transform: skewX(20deg);
            }

            //background: url('~@/assets/img/Arrow 62 1.png') no-repeat center #252525; 
            // background-size: 40px 28px;
          }

          .p-n {
            width: 70%;
            background: #252525;
            line-height: 50px;
            padding-left: 25px;
            color: #fff;
            font-weight: 600;
          }
        }

        .p-model {
          margin-top: 20px;
          font-weight: 600;
          color: #252525;
          font-size: 35px;
        }

        .p-title {
          font-size: 18px;
          width: 100%;
          overflow: hidden;
          margin-top: 50px;
          color: #02999d;
        }
      }

      .items {
        width: 100px;
        overflow: hidden;
        box-sizing: border-box;
        padding: 0px;
        float: left;

        .img-s:nth-child(1) {
          margin-top: 0px;
        }

        .img-s {
          cursor: pointer;
          width: 100%;
          overflow: hidden;
          display: none;
          margin-top: 20px;
          padding: 0px;
          box-sizing: border-box;
        }
      }
    }
  }
}

@media screen and (min-width: 1024px) and (max-width:1600px) {
  .factorydetail {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;


    .swiper-button-next:after,
    .swiper-container-rtl .swiper-button-prev:after {
      content: '' !important;
    }

    .swiper-button-prev:after,
    .swiper-container-rtl .swiper-button-next:after {
      content: '' !important;
    }

    .swiper-button-next {
      background: url('~@/assets/img/right (1).png') no-repeat center #252525;
      opacity: 0.9;
      width: 42px;
      transform: skewX(-15deg);
      height: 42px;
      background-size: 50%;
    }

    .swiper-button-next:hover {
      background: url('~@/assets/img/right (1).png') no-repeat center #02999d;
      opacity: 0.9;
      -webkit-transition: 0.6s ease-in-out;
      transition: 0.6s ease-in-out;
      width: 42px;
      transform: skewX(-15deg);
      height: 42px;
      background-size: 50%;
    }

    .swiper-button-prev:hover {
      -webkit-transition: 0.6s ease-in-out;
      transition: 0.6s ease-in-out;
      background: url('~@/assets/img/left.png') no-repeat center #02999d;
      opacity: 0.9;
      width: 42px;
      transform: skewX(-15deg);
      height: 42px;
      background-size: 50%;
    }

    .swiper-button-prev {
      background: url('~@/assets/img/left.png') no-repeat center #252525;
      width: 42px;
      opacity: 0.9;
      height: 42px;
      transform: skewX(-15deg);
      background-size: 50%;
    }

    .animate {
      opacity: 0;
    }

    .fadeInUpBig {
      animation: fadeInUpBig 1s;
    }

    .rollIn {
      animation: rollIn 1s;
    }

    .slideInRight {
      animation: slideInRight 1s;
    }

    .bounceInLeft {
      animation: bounceInLeft 2s ease-in;
    }

    .bounceInRight {
      animation: bounceInRight 2s ease-in;
    }


    .products-centers {
      width: 100%;
      overflow: hidden;
      margin: 80px auto auto auto;
      box-sizing: border-box;
      padding: 0px 0px 90px 0px;

      .slide-mores:hover {
        background: #02999d;
        border: 1px solid #02999d;
        color: #fff;
        -webkit-transition: 0.6s ease-in-out;
        transition: 0.6s ease-in-out;
      }

      .slide-mores {
        cursor: pointer;
        margin: 50px auto auto auto;
        background: none;
        color: #252525;
        text-align: center;
        transform: skewX(-20deg);
        border: 1px solid #252525;
        width: 88px;
        font-size: 14px;
        line-height: 30px;

        .slide-more {
          transform: skewX(20deg);
        }
      }

      .swiper-s {
        width: 1338px;
        overflow: hidden;
        position: relative;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;

        .swiper-container {
          width: 1200px;
          overflow: hidden;
          position: relative;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 0px;
        }
      }

      .products-nav-centers {
        position: relative;
        width: 1200px;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;
      }

      .products-leixing {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 212px;
        overflow: hidden;
      }

      .products-titles {
        color: #00959b;
        width: 100%;
        overflow: hidden;
        text-align: center;

      }

      .products-contents {
        color: #252525;
        width: 100%;
        overflow: hidden;
        text-align: center;
        font-size: 34px;
        margin-top: 30px;
        margin-bottom: 40px;
        font-weight: 600;
      }

      .swiper-items:hover {

        padding: 25px 45px 0px 45px;
        border-bottom: 4px solid #02999d;

        .direction:hover {
          width: 35px;
          height: 35px;
          background: url('~@/assets/img/right (1).png') no-repeat center #02999d;
          opacity: 0.9;
          -webkit-transition: 0.6s ease-in-out;
          transition: 0.6s ease-in-out;
          background-size: 60%;
          margin-top: 10px;
          border: 2px solid #02999d;
          margin-bottom: 20px;
          display: block;
        }

        .direction {
            width: 35px;
            height: 35px;
            background: url("~@/assets/img/right2.png") no-repeat center;
            background-size: 60%;
            margin-top: 10px;
            border: 2px solid #02999d;
            margin-bottom: 0px;
            display: block;
			     	transform: translate(0px,-480px);
        }

        img {
          -webkit-transition: 0.6s ease-in-out;
          transition: 0.6s ease-in-out;
          transform: scale(1.06);
          top: 90px;
          //transform: translate(0px,120px);
          //animation: pulse 2s infinite;
        }

        .models {
          font-size: 25px;
          width: 100%;
          overflow: hidden;
          font-weight: 600;
          color: #252525;
          -webkit-transition: 0.6s ease-in-out;
          transition: 0.6s ease-in-out;
          margin-top: 15px;
          display: block;
        }

        .model {
          //display: none;
          
          transform: translate(0px,-440px);
        }

        .title {
          //display: none;
          
          transform: translate(0px,-440px);
        }

        .titles {
          width: 100%;
          font-size: 18px;
          color: #02999d;
          box-sizing: border-box;
          padding: 0px;
          display: block;
          margin: 0px auto;
          overflow: hidden;
          -webkit-transition: 0.6s ease-in-out;
          transition: 0.6s ease-in-out;
        }
      }

      .swiper-items {
        width: 100%;
        height: 578.33px;
        overflow: hidden;
        box-sizing: border-box;
        padding: 45px 45px 0px 45px;
        background: #fff;
        cursor: pointer;

        img{
          position: absolute;
          top: 0px;
          left: 5%;
          color: #fff;
          transition: all ease 0.5s;
          text-align: center;
          width: 90%;
          height: auto;
        }
        .item-line{
          position: absolute;
          height: 4px;
          width: 0;
          bottom: 0px;
          background: #02999d;
          border-radius: 8px;
          left: 50%;
          bottom: 0px;
          transform: translate(-50%,-0%);
          transition: .4s all ease-in-out;
          z-index: 5;
        }  

        .direction {
          //display: none;
          width: 35px;
            height: 35px;
            background: url("~@/assets/img/right2.png") no-repeat center;
            background-size: 60%;
            margin-top: 10px;
            border: 2px solid #02999d;
            margin-bottom: 0px;
            display: block;
            position: absolute;
            bottom: -50px;
            left: 50px;
            transition: all ease 0.5s;
            z-index: 1;

        }

        .models {
          display: none;
        }

        .titles {
          display: none;
        }

        .model {
          font-size: 25px;
          width: 100%;
          overflow: hidden;
          font-weight: 600;
          //margin-bottom: 45px;
          color: #252525;
          //margin-top: 25px;

          position: absolute;
            bottom: 50px;
            left: 50px;
            transition: all ease 0.5s;
            z-index: 1;
        }

        .title {
          width: 100%;
          font-size: 18px;
          color: #02999d;
          box-sizing: border-box;
          padding: 0px;
          margin: 0px auto;
          overflow: hidden;

          position: absolute;
            bottom: 100px;
            left: 50px;
            transition: all ease 0.5s;
            z-index: 1;
        }
      }
    }

    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }

    .v-enter-active {
      transition: all 1s ease;
    }

    .contents {
      width: 100%;
      overflow: hidden;
      margin: 80px auto auto auto;
      padding-top: 90px;
      background: #ededed;

      .contents-des {
        width: 100%;
        margin: 80px auto auto auto;
        overflow: hidden;
        padding: 0px;
        box-sizing: border-box;

        .nav-body {
          width: 100%;
          overflow: hidden;
          margin: -4px auto;
          padding: 0px;
          background: #fff;
          box-sizing: border-box;
          img{
            width: 100%;
            height: auto;
          }
        
          .nav-content {
            width: 1200px;
            margin: 0px auto;
            padding: 50px;
            box-sizing: border-box;
           
          }
        }

        .nav-title {
          width: 100%;
          font-size: 25px;
          overflow: hidden;
          color: #252525;
          text-align: center;

          span {
            display: inline-block;
            overflow: hidden;
            padding-bottom: 20px;
            border-bottom: 4px solid #02999d;
          }
        }
      }

      .contents-top {
        width: 1200px;
        overflow: hidden;
        margin: 0px auto;
        padding: 0px;
        box-sizing: border-box;
      }

      .items-l {
        width: 680px;
        cursor: pointer;
        float: left;
        margin-left: 20px;
        overflow: hidden;
        display: block;
        box-sizing: border-box;
      }

      .items-t {
        width: calc(100% - 880px);
        overflow: hidden;
        float: left;
        margin-left: 80px;
        padding: 0px;
        box-sizing: border-box;

        .p-con {
          width: 100%;
          overflow: hidden;
          margin: 50px auto auto;
          padding: 0px;
          box-sizing: border-box;

          .p-b-s {
            width: 258px;
            overflow: hidden;
            padding: 0px;
            box-sizing: border-box;

            .p-ri:hover {
              .arrow-text {
                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
                float: right;
                width: 74px;
                color: #02999d;
                text-align: center;
                margin-top: 13.5px;

              }

              .arrow-le {
                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
                background: url('~@/assets/img/right (1).png') no-repeat center #02999d;
                width: 42px;
                opacity: 0.9;
                float: right;
                height: 42px;
                transform: skewX(-15deg);
                background-size: 50%;
              }
            }

            .p-ri {
              width: 128px;
              float: right;
              overflow: hidden;
              padding: 0px;
              box-sizing: border-box;
              cursor: pointer;
              padding-right: 10px;

              .arrow-text {
                float: right;
                width: 74px;
                color: #252525;
                text-align: center;
                margin-top: 13.5px;

              }

              .arrow-le {
                background: url('~@/assets/img/right (1).png') no-repeat center #252525;
                width: 42px;
                opacity: 0.9;
                float: right;
                height: 42px;
                transform: skewX(-15deg);
                background-size: 50%;
              }
            }

            .p-le:hover {
              .arrow-text {

                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
                float: left;
                width: 74px;
                color: #02999d;
                text-align: center;
                border-right: 1px solid #d9d9d9;
                margin-top: 13.5px;

              }

              .arrow-le {
                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
                background: url('~@/assets/img/left.png') no-repeat center #02999d;
                width: 42px;
                opacity: 0.9;
                float: left;
                height: 42px;
                transform: skewX(-15deg);
                background-size: 50%;
              }
            }

            .p-le {
              width: 128px;
              float: left;
              cursor: pointer;
              overflow: hidden;
              padding: 0px;
              box-sizing: border-box;
              padding-left: 10px;

              .arrow-text {
                float: left;
                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
                width: 74px;
                color: #252525;
                text-align: center;
                border-right: 1px solid #d9d9d9;
                margin-top: 13.5px;

              }

              .arrow-le {
                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
                background: url('~@/assets/img/left.png') no-repeat center #252525;
                width: 42px;
                opacity: 0.9;
                float: left;
                height: 42px;
                transform: skewX(-15deg);
                background-size: 50%;
              }
            }
          }
        }

        .p-share {
          width: 100%;
          overflow: hidden;
          margin: 50px auto;
          border-top: 1px solid #d9d9d9;
          border-bottom: 1px solid #d9d9d9;
          padding: 0px;
          font-weight: 600;
          box-sizing: border-box;
          .share-t:nth-child(1){
            width: 88px;
          }
          .share-t:hover {
            -webkit-transition: 0.8s ease-in-out;
            transition: 0.8s ease-in-out;
            animation: pulses 2s infinite;
          }

          .share-t {
            width: 10%;
            overflow: hidden;
            cursor: pointer;
            margin: 0px auto;
            float: left;
            padding: 0px;
            height: 85px;
            display: flex;
            align-items: center;
            /* 垂直居中 */
            justify-content: center;
            /* 水平居中，如果需要的话 */
            font-size: 25px;
            line-height: 85px;
            color: #252525;
            text-align: center;
          }

        }

        .phone_centers {
          width: 200px;
          margin-top: 50px;
          overflow: hidden;
          box-sizing: border-box;
          padding: 0px;
          position: relative;

          .call-tos {
            width: 20%;
            position: absolute;
            right: 12px;
            top: 0px;
            height: 50px;
            transform: skewX(-20deg);
            display: flex;
            align-items: center;
            /* 垂直居中 */
            justify-content: center;
            /* 水平居中，如果需要的话 */
            border: 1px solid #02999d;
            font-size: 14px;
            line-height: 30px;
            background: #02999d;

            .call-to {
              width: 20px;
              height: 14px;
              background: url('~@/assets/img/Arrow-s.png') no-repeat center;
              background-size: 20px 14px;
              transform: skewX(20deg);
            }

            //background: url('~@/assets/img/Arrow 62 1.png') no-repeat center #252525; 
            // background-size: 40px 28px;
          }

          .p-n {
            width: 70%;
            background: #252525;
            line-height: 50px;
            padding-left: 25px;
            color: #fff;
            font-weight: 600;
          }
        }

        .p-model {
          margin-top: 25px;
          font-weight: 600;
          color: #252525;
          font-size: 35px;
        }

        .p-title {
          font-size: 18px;
          width: 100%;
          overflow: hidden;
          margin-top: 70px;
          color: #02999d;
        }
      }

      .items {
        width: 100px;
        overflow: hidden;
        box-sizing: border-box;
        padding: 0px;
        float: left;

        .img-s:nth-child(1) {
          margin-top: 0px;
        }

        .img-s {
          cursor: pointer;
          width: 100%;
          overflow: hidden;
          margin-top: 20px;
          padding: 0px;
          box-sizing: border-box;
        }
      }
    }
  }


}

@media screen and (min-width: 1600px) and (max-width:8000px) {
  .factorydetail {
    width: 100%;
    overflow: hidden;
    margin: 0px auto;


    .swiper-button-next:after,
    .swiper-container-rtl .swiper-button-prev:after {
      content: '' !important;
    }

    .swiper-button-prev:after,
    .swiper-container-rtl .swiper-button-next:after {
      content: '' !important;
    }

    .swiper-button-next {
      background: url('~@/assets/img/right (1).png') no-repeat center #252525;
      opacity: 0.9;
      width: 42px;
      transform: skewX(-15deg);
      height: 42px;
      background-size: 50%;
    }

    .swiper-button-next:hover {
      background: url('~@/assets/img/right (1).png') no-repeat center #02999d;
      opacity: 0.9;
      -webkit-transition: 0.6s ease-in-out;
      transition: 0.6s ease-in-out;
      width: 42px;
      transform: skewX(-15deg);
      height: 42px;
      background-size: 50%;
    }

    .swiper-button-prev:hover {
      -webkit-transition: 0.6s ease-in-out;
      transition: 0.6s ease-in-out;
      background: url('~@/assets/img/left.png') no-repeat center #02999d;
      opacity: 0.9;
      width: 42px;
      transform: skewX(-15deg);
      height: 42px;
      background-size: 50%;
    }

    .swiper-button-prev {
      background: url('~@/assets/img/left.png') no-repeat center #252525;
      width: 42px;
      opacity: 0.9;
      height: 42px;
      transform: skewX(-15deg);
      background-size: 50%;
    }

    .animate {
      opacity: 0;
    }

    .fadeInUpBig {
      animation: fadeInUpBig 1s;
    }

    .rollIn {
      animation: rollIn 1s;
    }

    .slideInRight {
      animation: slideInRight 1s;
    }

    .bounceInLeft {
      animation: bounceInLeft 2s ease-in;
    }

    .bounceInRight {
      animation: bounceInRight 2s ease-in;
    }


    .products-centers {
      width: 100%;
      overflow: hidden;
      margin: 80px auto auto auto;
      box-sizing: border-box;
      padding: 0px 0px 90px 0px;

      .slide-mores:hover {
        background: #02999d;
        border: 1px solid #02999d;
        color: #fff;
        -webkit-transition: 0.6s ease-in-out;
        transition: 0.6s ease-in-out;
      }

      .slide-mores {
        cursor: pointer;
        margin: 50px auto auto auto;
        background: none;
        color: #252525;
        text-align: center;
        transform: skewX(-20deg);
        border: 1px solid #252525;
        width: 88px;
        font-size: 14px;
        line-height: 30px;

        .slide-more {
          transform: skewX(20deg);
        }
      }

      .swiper-s {
        width: 1738px;
        overflow: hidden;
        position: relative;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;

        .swiper-container {
          width: 1600px;
          overflow: hidden;
          position: relative;
          margin: 0px auto auto auto;
          box-sizing: border-box;
          padding: 0px;
        }
      }

      .products-nav-centers {
        position: relative;
        width: 1600px;
        overflow: hidden;
        margin: 0px auto auto auto;
        box-sizing: border-box;
        padding: 0px;
      }

      .products-leixing {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 212px;
        overflow: hidden;
      }

      .products-titles {
        color: #00959b;
        width: 100%;
        overflow: hidden;
        text-align: center;

      }

      .products-contents {
        color: #252525;
        width: 100%;
        overflow: hidden;
        text-align: center;
        font-size: 34px;
        margin-top: 30px;
        margin-bottom: 40px;
        font-weight: 600;
      }

      .swiper-items:hover {

        padding: 25px 45px 0px 45px;
        border-bottom: 4px solid #02999d;

        .direction:hover {
          width: 35px;
          height: 35px;
          background: url('~@/assets/img/right (1).png') no-repeat center #02999d;
          opacity: 0.9;
          -webkit-transition: 0.6s ease-in-out;
          transition: 0.6s ease-in-out;
          background-size: 60%;
          margin-top: 10px;
          border: 2px solid #02999d;
          margin-bottom: 20px;
          display: block;
        }

        .direction {
            width: 35px;
            height: 35px;
            background: url("~@/assets/img/right2.png") no-repeat center;
            background-size: 60%;
            margin-top: 10px;
            border: 2px solid #02999d;
            margin-bottom: 0px;
            display: block;
			     	transform: translate(0px,-480px);
        }

        img {
          -webkit-transition: 0.6s ease-in-out;
          transition: 0.6s ease-in-out;
          transform: scale(1.06);
          top: 90px;
          //transform: translate(0px,120px);
          //animation: pulse 2s infinite;
        }

        .models {
          font-size: 25px;
          width: 100%;
          overflow: hidden;
          font-weight: 600;
          color: #252525;
          -webkit-transition: 0.6s ease-in-out;
          transition: 0.6s ease-in-out;
          margin-top: 15px;
          display: block;
        }

        .model {
          //display: none;
          
          transform: translate(0px,-440px);
        }

        .title {
          //display: none;
          
          transform: translate(0px,-440px);
        }

        .titles {
          width: 100%;
          font-size: 18px;
          color: #02999d;
          box-sizing: border-box;
          padding: 0px;
          display: block;
          margin: 0px auto;
          overflow: hidden;
          -webkit-transition: 0.6s ease-in-out;
          transition: 0.6s ease-in-out;
        }
      }

      .swiper-items {
        width: 100%;
        width: 523.33px;
        height: 578.33px;
        overflow: hidden;
        box-sizing: border-box;
        padding: 45px 45px 0px 45px;
        background: #fff;
        cursor: pointer;

        img{
          position: absolute;
          top: 0px;
          left: 5%;
          color: #fff;
          transition: all ease 0.5s;
          text-align: center;
          width: 90%;
          height: auto;
        }
        .item-line{
          position: absolute;
          height: 4px;
          width: 0;
          bottom: 0px;
          background: #02999d;
          border-radius: 8px;
          left: 50%;
          bottom: 0px;
          transform: translate(-50%,-0%);
          transition: .4s all ease-in-out;
          z-index: 5;
        }  

        .direction {
          //display: none;
          width: 35px;
            height: 35px;
            background: url("~@/assets/img/right2.png") no-repeat center;
            background-size: 60%;
            margin-top: 10px;
            border: 2px solid #02999d;
            margin-bottom: 0px;
            display: block;
            position: absolute;
            bottom: -50px;
            left: 50px;
            transition: all ease 0.5s;
            z-index: 1;

        }

        .models {
          display: none;
        }

        .titles {
          display: none;
        }

        .model {
          font-size: 25px;
          width: 100%;
          overflow: hidden;
          font-weight: 600;
          //margin-bottom: 45px;
          color: #252525;
          //margin-top: 25px;

          position: absolute;
            bottom: 50px;
            left: 50px;
            transition: all ease 0.5s;
            z-index: 1;
        }

        .title {
          width: 100%;
          font-size: 18px;
          color: #02999d;
          box-sizing: border-box;
          padding: 0px;
          margin: 0px auto;
          overflow: hidden;

          position: absolute;
            bottom: 100px;
            left: 50px;
            transition: all ease 0.5s;
            z-index: 1;
        }
      }
    }

    .v-enter {
      opacity: 0;
      transform: translateY(150px);
    }

    .v-enter-active {
      transition: all 1s ease;
    }

    .contents {
      width: 100%;
      overflow: hidden;
      margin: 80px auto auto auto;
      padding-top: 90px;
      background: #ededed;

      .contents-des {
        width: 100%;
        margin: 80px auto auto auto;
        overflow: hidden;
        padding: 0px;
        box-sizing: border-box;

        .nav-body {
          width: 100%;
          overflow: hidden;
          margin: -4px auto;
          padding: 0px;
          background: #fff;
          box-sizing: border-box;
          img{
            width: 100%;
            height: auto;
          }
        
          .nav-content {
            width: 1600px;
            margin: 0px auto;
            padding: 50px;
            box-sizing: border-box;
           
          }
        }

        .nav-title {
          width: 100%;
          font-size: 25px;
          overflow: hidden;
          color: #252525;
          text-align: center;

          span {
            display: inline-block;
            overflow: hidden;
            padding-bottom: 20px;
            border-bottom: 4px solid #02999d;
          }
        }
      }

      .contents-top {
        width: 1600px;
        overflow: hidden;
        margin: 0px auto;
        padding: 0px;
        box-sizing: border-box;
      }

      .items-l {
        width: 680px;
        cursor: pointer;
        float: left;
        margin-left: 20px;
        overflow: hidden;
        display: block;
        box-sizing: border-box;
      }

      .items-t {
        width: calc(100% - 880px);
        overflow: hidden;
        float: left;
        margin-left: 80px;
        padding: 0px;
        box-sizing: border-box;

        .p-con {
          width: 100%;
          overflow: hidden;
          margin: 50px auto auto;
          padding: 0px;
          box-sizing: border-box;

          .p-b-s {
            width: 258px;
            overflow: hidden;
            padding: 0px;
            box-sizing: border-box;

            .p-ri:hover {
              .arrow-text {
                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
                float: right;
                width: 74px;
                color: #02999d;
                text-align: center;
                margin-top: 13.5px;

              }

              .arrow-le {
                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
                background: url('~@/assets/img/right (1).png') no-repeat center #02999d;
                width: 42px;
                opacity: 0.9;
                float: right;
                height: 42px;
                transform: skewX(-15deg);
                background-size: 50%;
              }
            }

            .p-ri {
              width: 128px;
              float: right;
              overflow: hidden;
              padding: 0px;
              box-sizing: border-box;
              cursor: pointer;
              padding-right: 10px;

              .arrow-text {
                float: right;
                width: 74px;
                color: #252525;
                text-align: center;
                margin-top: 13.5px;

              }

              .arrow-le {
                background: url('~@/assets/img/right (1).png') no-repeat center #252525;
                width: 42px;
                opacity: 0.9;
                float: right;
                height: 42px;
                transform: skewX(-15deg);
                background-size: 50%;
              }
            }

            .p-le:hover {
              .arrow-text {

                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
                float: left;
                width: 74px;
                color: #02999d;
                text-align: center;
                border-right: 1px solid #d9d9d9;
                margin-top: 13.5px;

              }

              .arrow-le {
                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
                background: url('~@/assets/img/left.png') no-repeat center #02999d;
                width: 42px;
                opacity: 0.9;
                float: left;
                height: 42px;
                transform: skewX(-15deg);
                background-size: 50%;
              }
            }

            .p-le {
              width: 128px;
              float: left;
              cursor: pointer;
              overflow: hidden;
              padding: 0px;
              box-sizing: border-box;
              padding-left: 10px;

              .arrow-text {
                float: left;
                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
                width: 74px;
                color: #252525;
                text-align: center;
                border-right: 1px solid #d9d9d9;
                margin-top: 13.5px;

              }

              .arrow-le {
                -webkit-transition: 0.6s ease-in-out;
                transition: 0.6s ease-in-out;
                background: url('~@/assets/img/left.png') no-repeat center #252525;
                width: 42px;
                opacity: 0.9;
                float: left;
                height: 42px;
                transform: skewX(-15deg);
                background-size: 50%;
              }
            }
          }
        }

        .p-share {
          width: 100%;
          overflow: hidden;
          margin: 50px auto;
          border-top: 1px solid #d9d9d9;
          border-bottom: 1px solid #d9d9d9;
          padding: 0px;
          font-weight: 600;
          box-sizing: border-box;
          .share-t:hover {
            -webkit-transition: 0.8s ease-in-out;
            transition: 0.8s ease-in-out;
            animation: pulses 2s infinite;
          }

          .share-t {
            width: 10%;
            overflow: hidden;
            cursor: pointer;
            margin: 0px auto;
            float: left;
            padding: 0px;
            height: 85px;
            display: flex;
            align-items: center;
            /* 垂直居中 */
            justify-content: center;
            /* 水平居中，如果需要的话 */
            font-size: 25px;
            line-height: 85px;
            color: #252525;
            text-align: center;
          }

        }

        .phone_centers {
          width: 200px;
          margin-top: 50px;
          overflow: hidden;
          box-sizing: border-box;
          padding: 0px;
          position: relative;

          .call-tos {
            width: 20%;
            position: absolute;
            right: 12px;
            top: 0px;
            height: 50px;
            transform: skewX(-20deg);
            display: flex;
            align-items: center;
            /* 垂直居中 */
            justify-content: center;
            /* 水平居中，如果需要的话 */
            border: 1px solid #02999d;
            font-size: 14px;
            line-height: 30px;
            background: #02999d;

            .call-to {
              width: 20px;
              height: 14px;
              background: url('~@/assets/img/Arrow-s.png') no-repeat center;
              background-size: 20px 14px;
              transform: skewX(20deg);
            }

            //background: url('~@/assets/img/Arrow 62 1.png') no-repeat center #252525; 
            // background-size: 40px 28px;
          }

          .p-n {
            width: 70%;
            background: #252525;
            line-height: 50px;
            padding-left: 25px;
            color: #fff;
            font-weight: 600;
          }
        }

        .p-model {
          margin-top: 25px;
          font-weight: 600;
          color: #252525;
          font-size: 35px;
        }

        .p-title {
          font-size: 18px;
          width: 100%;
          overflow: hidden;
          margin-top: 70px;
          color: #02999d;
        }
      }

      .items {
        width: 100px;
        overflow: hidden;
        box-sizing: border-box;
        padding: 0px;
        float: left;

        .img-s:nth-child(1) {
          margin-top: 0px;
        }

        .img-s {
          cursor: pointer;
          width: 100%;
          overflow: hidden;
          margin-top: 20px;
          padding: 0px;
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>
